import {useRef} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import Call from "../../hocs/call";
import SettingsDialog from "../settings-dialog";
import AiSearchEngineForm from "./AiSearchEngineForm";
import {
  fetchSearchEngineSettings,
  hideSearchEngineSettingsModal,
  submitSearchEngineSettings
} from "../../state/ai-assistant/aiAssistantAction";
import {aiNodeSettingsSelector} from "../../state/ai-assistant/aiAssistantSelector";
import {externalServicesSelector} from "../../state/config/configSelectors";

const AiSearchEngineSettings = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const baseUrl = useSelector(externalServicesSelector)?.ai;
  const {isAiSearchEngineSettingsVisible, searchEngineId, nodeId, searchEngineSettings, authToken} =
    useSelector(aiNodeSettingsSelector);

  const formRef = useRef();

  const getSearchEngineSettings = ({nodeId, searchEngineId, baseUrl}) =>
    dispatch(fetchSearchEngineSettings(nodeId, searchEngineId, baseUrl, authToken));

  const handleSubmit = data => dispatch(submitSearchEngineSettings(nodeId, searchEngineId, data, baseUrl, authToken));

  return (
    <SettingsDialog
      title={
        searchEngineId
          ? t("modules.aiAssistant.aiSettings.searchEngineSettings.editSearchEngine")
          : t("modules.aiAssistant.aiSettings.searchEngineSettings.createSearchEngine")
      }
      open={isAiSearchEngineSettingsVisible}
      onClose={() => dispatch(hideSearchEngineSettingsModal())}
      onSubmit={() => formRef.current?.submit()}
    >
      <Call
        cb={getSearchEngineSettings}
        cbParam={{nodeId, searchEngineId, baseUrl}}
        disabled={!nodeId || !searchEngineId || searchEngineSettings}
      >
        {searchEngineId ? (
          searchEngineSettings && (
            <AiSearchEngineForm ref={formRef} initialData={searchEngineSettings} onSubmit={handleSubmit} />
          )
        ) : (
          <AiSearchEngineForm ref={formRef} onSubmit={handleSubmit} />
        )}
      </Call>
    </SettingsDialog>
  );
};

export default AiSearchEngineSettings;
